export let spaces = [{
    "image": "../../assets/images/splashpaint1.png",
    "name": "Mood Tracker",
    "link": "/dashboard"
},
{
    "image": "../../assets/images/splashpaint2.png",
    "name": "Activities",
    "link": "/activities"
},
{
    "image": "../../assets/images/splashpaint3.png",
    "name": "Safe rooms",
    "link": "/saferoom"
},
{
    "image": "../../assets/images/splashpaint4.png",
    "name": "Forums",
    "link": "/forum"
},
]